export const reportName = name => {
    switch (name) {
        case 'StandardReport':
            return 'Standardrapport';
        case 'OverviewReport':
            return 'Översiktsrapport';
        case 'TotalReport':
            return 'Totalrapport';
        default:
            return '';
    }
};